import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';

function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const [status, setStatus] = useState('verifying'); // 'verifying', 'success', 'error'
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verify = async () => {
      if (!token) {
        setStatus('error');
        setMessage('Verification token is missing.');
        return;
      }
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/verify-email?token=${token}`
        );
        const data = await response.json();
        if (!response.ok) {
          throw new Error(data.error || 'Verification failed');
        }
        setStatus('success');
        setMessage(data.message);
      } catch (err) {
        setStatus('error');
        setMessage(err.message);
        console.error('Email verification error:', err);
      }
    };
    verify();
  }, [token]);

  return (
    <main className="App-main">
      <h2>Email Verification</h2>
      {status === 'verifying' && <p>Verifying your email...</p>}
      {status === 'success' && (
        <>
          <p className="success-message">{message}</p>
          <p>
            {localStorage.getItem('token')
              ? <Link to="/landlord/dashboard/v2">Go to dashboard</Link>
              : <>You can now <Link to="/login">login</Link> to your account.</>
            }
          </p>
        </>
      )}
      {status === 'error' && (
        <>
          <p className="error-message">{message}</p>
          <p>
            If you need a new verification email, go to <Link to="/register">Register</Link> page and use the resend option.
          </p>
        </>
      )}
    </main>
  );
}

export default VerifyEmail;
